module.exports = __webpack_public_path__ + "img/PPMPRA3.e12fef48.png";